module.exports = __webpack_public_path__ + "img/icon-yuan-1.c730b32a.png";